export default __webpack_public_path__ + "static/media/player_pause.2961475f.svg";